var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'gt-footer-fixer',
    _vm.withDefaultStyle ? 'gt-footer-fixer--default' : '',
    _vm.customClass || ''
  ],style:({
    left: _vm.positionLeft,
    right: _vm.positionRight
  })},[(_vm.$slots.default)?_c('div',{staticClass:"gt-footer-fixer__inner"},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }